<template>
	<!-- 主页面 -->
	<div class="home" @click="recordActiveTime">
		<div class="homePC">
			<!-- 侧导航 -->
			<div class="homePC-side" :class="isCollapse ? 'homePC-side-width' : ''" :style="sideStyle">
				<div class="homePC-side-nav">
					<div class="homePC-side-logo">
						<div class="homePC-side-logo-text"><img src="../../assets/images/logo/HF.png" alt=""><span
								v-if='isCollapse == false'>飞砂走石</span></div>
					</div>
					<el-menu :default-active="$route.path" @select="twoSelet" :collapse='isCollapse'
							class="homePC-side-nav-ul" @open="handleOpen" @close="handleClose" background-color="transparent"
							text-color="#526477" active-text-color="#178bff">
							<el-menu-item v-for="(item, index) in twoNavlist" :key="item.PERTB001CA03"
								style="font-size: 16px;" :index="item.PERTB001CA03">
								<i class="el-icon-menu"></i>
								<span slot="title">{{ item.PERTB001CA00 }}</span>
							</el-menu-item>
						</el-menu>
				</div>
				<div class="homePC-side-btn pulic_cursor" :class="isCollapse ? 'homePC-side-btn-left' : ''"
					@click="iscoll">
					<span class="el-icon-arrow-left" v-if="isCollapse == false"></span>
					<span class="el-icon-arrow-right" v-if="isCollapse == true"></span>
				</div>

			</div>
			<!-- 右边主题内容 -->
			<div class="homePC-content">

				<div class="homePC-content-title">
					<div class="homePC-content-title-nav">
						<el-menu class="oneLevelSty" :default-active="oneNavDefActive" mode="horizontal"
								@select="handleSelect">
								<el-menu-item v-for="item in oneNavlist" :key="item.PERTB001ID"
									:index="item.PERTB001CA03">{{ item.PERTB001CA00 }}
								</el-menu-item>
							</el-menu>
					</div>
					<div class="homePC-content-title-btn">
						<div class="homePC-content-title-btn-headerPro pulic_cursor">
							<div>
								<img src="../../assets/images/heaPortrait/Headportrait.png" alt="">
							</div>
						</div>
						<el-popover placement="bottom" width="200px" trigger="click" @show="queryaccount">
							<div slot="reference" class="homePC-content-title-btn-text pulic_cursor">
								<p>{{ userName }}</p>
								<p>{{ $store.state.uobj.enterpriseName || '飞砂走石云平台' }}</p>
							</div>
							<div class="homePC-content-title-account">
								<el-divider>切换账号</el-divider>
								<template v-for="(item, index) in accountList">
									<el-tooltip :key="index" class="item" effect="dark"
										:content="item.enterpriseName ? item.enterpriseName : '郑州小石头'"
										placement="bottom">
										<div class="homePC-content-title-account-li public-hover pulic_cursor"
											:class="erpId == item.pertb005.pertb005cd01 ? 'homePC-content-title-account-li-color' : ''"
											@click="switchAccount(item)">
											{{ item.enterpriseName ? item.enterpriseName : '郑州小石头' }}
										</div>
									</el-tooltip>
								</template>
							</div>
						</el-popover>
						<div class="homePC-content-title-btn-icon pulic_cursor" @click="outClick">
							<span class="el-icon-switch-button"></span>
						</div>
						<div class="public-dialog">
							<el-dialog title="个人信息" :visible.sync="personalInformation" width="30%" append-to-body custom-class="home-dialog">
								<div class="systemUserPC-add-user">
									<div class="systemUserPC-add-user-table">

										<div class="systemUserPC-add-user-li">
											<div>姓名</div>
											<div>
												<input type="text" value="" maxlength="16" v-model="modifyNameHome" />
											</div>
											<div>*必填*</div>
										</div>

										<div class="systemUserPC-add-user-li">
											<div>登录方式</div>
											<div>
												<el-select v-model="modifyLoginMethod">
													<el-option v-for="item in modifyLoginMethodList" :key="item.value"
														:label="item.label" :value="item.value">
													</el-option>
												</el-select>
											</div>
											<div>*必填*</div>
										</div>
									</div>
									<div class="systemUserPC-add-user-btn">
										<el-button type="primary" @click="modifyPersonalInformation">保存</el-button>
										<el-button type="warning" @click="cancelPersonalInformation">取消</el-button>
									</div>
								</div>
							</el-dialog>
						</div>
					</div>
				</div>
				<div class="homePC-content-lable">
					<div class="homePC-content-lable-tabs" :style="tabsStyle">
						<el-tabs v-model="$store.state.setHistTabsValue" type="card" closable @tab-remove="removeTab"
							@tab-click="tabClick">
							<el-tab-pane v-for="item in $store.state.tablist" :key="item.PERTB001CA03"
								:label="item.PERTB001CA00" :name="item.PERTB001CA03">
							</el-tab-pane>
						</el-tabs>
					</div>
					<div class="homePC-content-lable-btn">
						<el-popover placement="bottom" width="130" trigger="click">
							<span slot="reference" class="homePC-content-lable-btn-ico iconfont icon-xiangxia"></span>
							<div class="homePC-content-lable-btn-COT">
								<ul>
									<li @click="downCurrent">关闭当前标签页</li>
									<li @click="downOther">关闭其它标签页</li>
									<li @click="downAll">关闭全部标签页</li>
								</ul>
							</div>
						</el-popover>
					</div>
				</div>
				<div v-show="show" class="homePC-content-router">
					<!-- <router-view /> -->
					<keep-alive :max="keepAliveMax"> <!-- 限制最大缓存数 -->
						<router-view :key="$route.path" />
					</keep-alive>
				</div>
			</div>
			<audio id="music1" style="display: none;">
				<source src="../../assets/images/order.wav">
			</audio>
		</div>
	</div>
</template>

<script>
export default {

	data() {
		return {
			tabsStyle: '',
			sideStyle: '',
			isCollapse: false,
			pertb001List: '',
			oneNavlist: [],
			twoNavlist: [],
			oneNavDefActive: '',
			uobj: '',
			userName: '',
			imgSrc: '../../assets/images/heaPortrait/Headportrait.png',
			accountList: [],
			keepAliveMax: 20,
			timeOut: 8 * 60 * 60 * 1000, // 设置超时时间:30分钟
			erpId: '',
			// 个人信息
			personalInformation: false,
			modifyNameHome: '',
			modifyLoginMethod: '',
			modifyLoginMethodList: [{
				value: 'MM',
				label: '密码'
			},
			{
				value: 'YZM',
				label: '验证码'
			},
			],
			show: true,
			socket: null,
			// 审核
			InvenAuditCountAll: 0, //充值审核
			DispatchAuditCountAll: 0, //销售派单审核
			TopUpAuditCountAll: 0, //销售充值审核
			menuCache: Object.freeze({}), // 菜单结构缓存
			beforeUnloadHandler: null,
			keepLoginTimer: null,
			resizeHandler: null,
			dispatchAuditTimer: null,
			isHomeDestroyed: false,
		}
	},
	mounted() {
		this.resizeHandler = () => this.updateShellSize()
		this.updateShellSize()
		window.addEventListener('resize', this.resizeHandler)
		this.isTimeOut()
		if (this.$store.state.uobj.pertb005.pertb005cb00 == 'CUS-1') {
			this.queryDispatchAuditHome()
		}

	},
	created() {
		this.lastActiveTime = Date.now()
		this.routeComponentCache = Object.create(null)
		this.routePreloadedMap = Object.create(null)
		this.preloadTimer = null
		this.routePushTimer = null
		this.initNav()
		this.erpId = this.$store.state.uobj.pertb005.pertb005cd01
		this.bindBeforeUnload()
		// 清理旧的路由缓存
		if (this.$route.meta.keepAlive) {
			const cache = this.$vnode.parent.componentInstance.cache;
			const keys = this.$vnode.parent.componentInstance.keys;
			for (const key in cache) {
				if (!keys.includes(key)) {
					delete cache[key];
				}
			}
		}
	},
	beforeDestroy() {
		this.isHomeDestroyed = true
		if (this.resizeHandler) {
			window.removeEventListener('resize', this.resizeHandler)
			this.resizeHandler = null
		}
		if (this.beforeUnloadHandler) {
			window.removeEventListener('beforeunload', this.beforeUnloadHandler)
			this.beforeUnloadHandler = null
		}
		clearTimeout(this.keepLoginTimer)
		clearTimeout(this.dispatchAuditTimer)
		clearTimeout(this.preloadTimer)
		clearTimeout(this.routePushTimer)
		this.keepLoginTimer = null
		this.dispatchAuditTimer = null
		this.preloadTimer = null
		this.routePushTimer = null
	},
	methods: {
		updateShellSize() {
			if (window.innerWidth <= 768) {
				this.sideStyle = ''
				this.tabsStyle = ''
				return
			}
			this.$nextTick(() => {
				var tabsEl = document.querySelector('.homePC-content-lable-tabs')
				var tabsW = tabsEl ? Math.max(tabsEl.clientWidth - 60, 240) : 240
				var windowH = window.innerHeight
				this.tabsStyle = `width:${tabsW}px`
				this.sideStyle = `min-height:${windowH}px`
			})
		},
		bindBeforeUnload() {
			if (this.beforeUnloadHandler) return
			this.beforeUnloadHandler = () => {
				var obj = {
					oneNavDefActive: this.oneNavDefActive,
					editableTabsValue: this.$store.state.setHistTabsValue,
					editableTabs: this.$store.state.tablist
				}
				this.$store.commit('setNavHistoy', obj)
				if (this.$store.state.tablist.length > 0) {
					sessionStorage.setItem('HistoyLObj', JSON.stringify(this.$store.state))
				}
			}
			window.addEventListener('beforeunload', this.beforeUnloadHandler)
		},
		// 查询个人登录信息
		querypersonalClick() {
			this.personalInformation = true
			this.querypersonalPost()
		},
		querypersonalPost() {
			var url = "/per/pertb005/selectPertb005ById"
			var data = {
				PERTB005ID: this.$store.state.uobj.pertb005.pertb005id,
			}
			this.axios.post(url, data).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					var data = res.data.data
					this.modifyNameHome = data['PERTB005CA02']
					if (data['PERTB005CA04'] == 'MM') {
						this.modifyLoginMethod = this.modifyLoginMethodList[0]["value"];
					} else if (data['PERTB005CA04'] == 'YZM') {
						this.modifyLoginMethod = this.modifyLoginMethodList[1]["value"];
					}

				} else {
					this.$message({
						type: 'error',
						message: res.data.message
					});
				}
			})
		},
		cancelPersonalInformation() {
			this.personalInformation = false
		},

		queryDispatchAuditHome() { //待审核条数比对
			if (this.dispatchAuditTimer) {
				clearTimeout(this.dispatchAuditTimer)
				this.dispatchAuditTimer = null
			}
			var postData = {
				ORMTB440CA02: this.$store.state.uobj.pertb005['pertb005cd01'], //一级企业id
			}
			var url = "/orm/ormtb440/remind";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 201) {
					// this.closeMp3DispatchHome()
					// this.noticeDispatchHome();
					console.log()
				}
			}).catch(() => { }).then(() => {
				if (this.isHomeDestroyed || this.$route.path == '/Login') return
				this.dispatchAuditTimer = setTimeout(() => {
					this.queryDispatchAuditHome()
				}, 60000);
			});
		},
		// 提示音
		closeMp3DispatchHome() {
			var audio = document.getElementById('music1');
			if (audio.paused) {
				audio.play(); // 播放
			} else {
				audio.pause(); // 暂停
			}
		},
		// 有新待审核通知框 
		// noticeDispatchHome() {
		// 	const h = this.$createElement;
		// 	this.$notify({
		// 		title: '销售派单通知',
		// 		message: h('i', {
		// 			style: 'color: red'
		// 		}, '您有新的销售派单，请尽快审核！！！'),
		// 		position: 'bottom-right',
		// 		duration: 15000
		// 	});
		// },
		// 修改个人信息
		modifyPersonalInformation() {
			// console.log(this.modifyNameHome)
			// console.log(this.modifyLoginMethod)
			if (this.modifyNameHome == '') {
				this.$message({
					message: "姓名不能为空",
					type: "error",
				});
			} else if (this.modifyLoginMethod == '') {
				this.$message({
					message: "登录方式不能为空",
					type: "error",
				});
			} else {
				this.modifyPersonalInPost();
			}
		},
		modifyPersonalInPost() {
			let loading = this.$loading({
				lock: true,
				text: "请求中...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.5)",
			});
			var postData = {
				PERTB005CA02: this.modifyNameHome, //用户姓名
				PERTB005CA04: this.modifyLoginMethod, //登录方式（MM密码YZM验证码）
				PERTB005ID: this.$store.state.uobj.pertb005.pertb005id,
			};
			var url = "/per/pertb005/updatePertb005ById";
			this.axios.post(url, postData).then((res) => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$alert(`修改成功需退出重新登录？`, '提示', {
						confirmButtonText: '确定',
						callback: action => {
							this.$router.push('/Login');
						},
					});
				} else {
					this.$message({
						message: res.data.message,
						type: "error",
					});
				}
				setTimeout(() => {
					loading.close();
				}, 300);
			})
				.catch(() => {
					loading.close();
				});
		},
		queryaccount() { //获取账号
			this.accountList = []
			var url = "/system/login/queryOtherAccount"
			var data = {
				PERTB005CA03: this.$store.state.uobj.pertb005.pertb005ca03,
				PERTB005CB00: this.$store.state.uobj.pertb005.pertb005cb00,
				PERTB005CD01: this.$store.state.uobj.pertb005.pertb005cd01
			}
			this.axios.post(url, data).then(res => {
				// console.log(res)
				if (res.data.code == 200) this.accountList = res.data.data || []
			})
		},
		switchAccount(item) { //切换账号
			this.$confirm(`请确认是否切换账号：${item.enterpriseName ? item.enterpriseName : '小石头'}`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.upaccount(item)
			}).catch(() => {

			});
		},
		handleOpen(key, keyPath) { //侧导航展开
		},
		handleClose(key, keyPath) { //侧导航收起
		},
		handleSelect(key, keyPath) {
			var activeKey = keyPath[0]
			var activeMenu = this.oneNavlist.find(item => item.PERTB001CA03 == activeKey)
			if (!activeMenu || !activeMenu.childMenus || activeMenu.childMenus.length == 0) return
			var firstTab = activeMenu.childMenus[0]
			this.oneNavDefActive = activeKey
			this.twoNavlist = activeMenu.childMenus
			this.addHistoryTab(firstTab)
			this.$store.commit('setHistTabsValue', firstTab.PERTB001CA03)
			this.pushRoute(firstTab.PERTB001CA03)
		},
		twoSelet(key, keyPath) { //二级选中
			var path = keyPath[0]
			var selectedMenu = this.twoNavlist.find(item => item.PERTB001CA03 == path)
			if (selectedMenu) {
				this.addHistoryTab(selectedMenu, path == '/Home/chargingOrder' || path == '/Home/alarmInformation')
			}
			this.$store.commit('setHistTabsValue', path)
			this.pushRoute(path)
		},
		addHistoryTab(tab, replaceSameBizTab) {
			if (!tab || !tab.PERTB001CA03) return
			var path = tab.PERTB001CA03
			var tabs = this.$store.state.tablist
			var nextTabs = tabs
			if (replaceSameBizTab) {
				nextTabs = tabs.filter(item => item.PERTB001CA05 !== tab.PERTB001CA05)
			}
			if (nextTabs.some(item => item.PERTB001CA03 === path)) {
				if (nextTabs !== tabs) this.$store.commit('upEditableTabs', nextTabs)
				return
			}
			this.$store.commit('upEditableTabs', nextTabs.concat(tab))
			sessionStorage.removeItem(path)
		},
		pushRoute(path) {
			if (!path || this.$route.path === path) return
			clearTimeout(this.routePushTimer)
			this.routePushTimer = setTimeout(() => {
				if (!this.isHomeDestroyed && this.$route.path !== path) this.$router.push(path)
			}, 16)
		},
		buildMenuCache(list) {
			var cache = {}
			;(list || []).forEach(resitem => {
				var childMenus = resitem.childMenus || []
				childMenus.forEach(resitem1 => {
					cache[resitem1.PERTB001CA03] = {
						twoNavlist: childMenus,
						oneNavDefActive: resitem.PERTB001CA03
					}
				})
			})
			this.menuCache = Object.freeze(cache)
		},
			buildRouteComponentCache() {
				var homeRoute = (this.$router.options.routes || []).find(item => item.path === '/Home')
				var cache = {}
				;((homeRoute && homeRoute.children) || []).forEach(item => {
					var path = item.path.indexOf('/') === 0 ? item.path : '/Home/' + item.path
					cache[path] = item.component
				})
				this.routeComponentCache = Object.freeze(cache)
			},
			requestIdle(callback) {
				if (window.requestIdleCallback) {
					return window.requestIdleCallback(callback, { timeout: 4000 })
				}
				return setTimeout(() => callback({ timeRemaining: () => 0 }), 1500)
			},
			preloadFirstChildRoute(menu) {
				if (menu && menu.childMenus && menu.childMenus[0]) this.preloadRoute(menu.childMenus[0].PERTB001CA03)
			},
			preloadRoute(path) {
				if (!path || this.routePreloadedMap[path]) return
				var loader = this.routeComponentCache && this.routeComponentCache[path]
				if (typeof loader !== 'function') return
				this.routePreloadedMap[path] = true
				var res = loader()
				if (res && res.catch) {
					res.catch(() => {
						this.routePreloadedMap[path] = false
					})
				}
			},
			schedulePreloadRoutes() {
				clearTimeout(this.preloadTimer)
				var paths = []
				;(this.$store.state.tablist || []).forEach(item => paths.push(item.PERTB001CA03))
				;(this.twoNavlist || []).slice(0, 2).forEach(item => paths.push(item.PERTB001CA03))
				paths = Array.from(new Set(paths)).filter(Boolean).slice(0, 4)
				var index = 0
				var preloadNext = deadline => {
					if (this.isHomeDestroyed || index >= paths.length) return
					if (deadline && deadline.timeRemaining && deadline.timeRemaining() < 8) {
						this.preloadTimer = setTimeout(() => this.requestIdle(preloadNext), 1200)
						return
					}
					this.preloadRoute(paths[index++])
					this.preloadTimer = setTimeout(() => this.requestIdle(preloadNext), 1800)
				}
				this.preloadTimer = setTimeout(() => this.requestIdle(preloadNext), 2500)
			},
		// removeTab(targetName) { //关闭历史标签页
		// 	sessionStorage.removeItem(targetName)
		// 	let tabs = this.$store.state.tablist;
		// 	let activeName = this.$store.state.setHistTabsValue;
		// 	if (activeName === targetName) {
		// 		tabs.forEach((tab, index) => {
		// 			if (tab.PERTB001CA03 === targetName) {
		// 				let nextTab = tabs[index + 1] || tabs[index - 1];
		// 				if (nextTab) {
		// 					activeName = nextTab.PERTB001CA03;
		// 				}
		// 			}
		// 		});
		// 	}
		// 	this.$store.commit('setHistTabsValue', activeName)
		// 	this.$store.state.tablist = tabs.filter(tab => tab.PERTB001CA03 !== targetName);
		// 	if (this.$store.state.tablist.length == 0) {
		// 		var Stablsit = this.$store.state.tablist.slice()
		// 		Stablsit.push(this.twoNavlist[0])
		// 		this.$store.commit('upEditableTabs', Stablsit)
		// 		this.$store.commit('setHistTabsValue', this.twoNavlist[0].PERTB001CA03)
		// 	} else {
		// 		let pertb001List = this.$store.state.uobj.pertb001List
		// 		pertb001List.forEach(resitem => {
		// 			resitem.childMenus.forEach(resitem1 => {
		// 				if (this.$store.state.setHistTabsValue == resitem1.PERTB001CA03) {
		// 					this.twoNavlist = resitem.childMenus
		// 					this.oneNavDefActive = resitem.PERTB001CA03
		// 				}
		// 			})
		// 		})
		// 	}
		// 	this.$router.push(this.$store.state.setHistTabsValue)
		// },
		removeTab(targetName) { //关闭历史标签页
			sessionStorage.removeItem(targetName)
			let tabs = this.$store.state.tablist
			let activeName = this.$store.state.setHistTabsValue
			if (activeName === targetName) {
				const currentIndex = tabs.findIndex(tab => tab.PERTB001CA03 === targetName)
				let nextTab = null
				for (let i = currentIndex + 1; i < tabs.length; i++) {
					if (tabs[i]) {
						nextTab = tabs[i]
						break
					}
				}
				if (!nextTab) {
					for (let i = currentIndex - 1; i >= 0; i--) {
						if (tabs[i]) {
							nextTab = tabs[i]
							break
						}
					}
				}
				if (nextTab) activeName = nextTab.PERTB001CA03
			}
			const newTabs = tabs.filter(tab => tab.PERTB001CA03 !== targetName)
			if (newTabs.length === 0) {
				const defaultTab = this.twoNavlist[0]
				if (!defaultTab) return
				this.$store.commit('upEditableTabs', [defaultTab])
				this.$store.commit('setHistTabsValue', defaultTab.PERTB001CA03)
				this.pushRoute(defaultTab.PERTB001CA03)
				this.updateMenuByPath(defaultTab.PERTB001CA03)
			} else {
				this.$store.commit('upEditableTabs', newTabs)
				this.$store.commit('setHistTabsValue', activeName)
				this.pushRoute(activeName)
				this.updateMenuByPath(activeName)
			}
		},
		tabClick(target) { //切换历史标签页
			if (this.$route.path === target.name) {
				this.updateMenuByPath(target.name)
				return
			}
			this.$store.commit('setHistTabsValue', target.name)
			this.pushRoute(target.name)
			this.updateMenuByPath(target.name)
		},
		updateMenuByPath(path) {
			var cacheItem = this.menuCache && this.menuCache[path]
			if (cacheItem) {
				this.twoNavlist = cacheItem.twoNavlist
				this.oneNavDefActive = cacheItem.oneNavDefActive
				return
			}
			var pertb001List = this.$store.state.uobj.pertb001List || []
			pertb001List.forEach(resitem => {
				var childMenus = resitem.childMenus || []
				childMenus.forEach(resitem1 => {
					if (path == resitem1.PERTB001CA03) {
						this.twoNavlist = childMenus
						this.oneNavDefActive = resitem.PERTB001CA03
					}
				})
			})
		},
		downCurrent() { //关闭当前
			sessionStorage.removeItem(this.$store.state.setHistTabsValue)
			this.removeTab(this.$store.state.setHistTabsValue)
		},
		downOther() { //关闭其他
			var activePath = this.$store.state.setHistTabsValue
			var arr = this.$store.state.tablist.filter(resitem => {
				if (resitem.PERTB001CA03 == activePath) return true
				sessionStorage.removeItem(resitem.PERTB001CA03)
				return false
			})
			this.$store.commit('upEditableTabs', arr)
			this.pushRoute(activePath)
			this.updateMenuByPath(activePath)
		},
		downAll() { //关闭全部
			this.$store.state.tablist.forEach(resitem => {
				sessionStorage.removeItem(resitem.PERTB001CA03)
			})
			const defaultTab = this.twoNavlist[0]
			if (!defaultTab) return
			this.$store.commit('upEditableTabs', [defaultTab])
			this.$store.commit('setHistTabsValue', defaultTab.PERTB001CA03)
			this.pushRoute(defaultTab.PERTB001CA03)
			this.updateMenuByPath(defaultTab.PERTB001CA03)
		},
		iscoll() {
			this.isCollapse = !this.isCollapse
			setTimeout(() => {
				this.updateShellSize()
			}, 240)
		},
		sockClose() {


			// console.log(this.socket.close())
			// this.socket.onclose = function(e) {
			// 	console.log(e); //监听关闭事件
			// };
		},
		// beforeDestroy() {
		// 	this.sockClose(); // 确保组件销毁前断开连接
		// },

		outClick() { //退出登录
			this.$confirm(`请确认是否退出登录？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				// var url = '/system/logout'
				// this.axios.get(url).then((res) => {
				// console.log(res)
				// if (res.data.code == 200) {
				this.$router.push('/Login')
				sessionStorage.removeItem('token')
				// this.sockClose()
				this.$store.commit('setUser', '')
				this.$store.commit('setNavHistoy', '')
				this.$store.commit('setSole', '')
				this.$store.commit('upEditableTabs', [])
				this.$store.commit('setHistTabsValue', '')
				// this.$forceUpdate()
				location.reload()
				// }
				// }).catch(() => {
				// this.$router.push('/Login')
				// });
			}).catch(() => {

			});
		},
		initNav() { //初始化导航数据
			var HistoyLObj = JSON.parse(sessionStorage.getItem('HistoyLObj'))
			if (HistoyLObj != null) {
				this.$store.commit('setUser', HistoyLObj.uobj)
				this.$store.commit('setNavHistoy', HistoyLObj.NavHistoyLObj)
				this.$store.commit('setSole', HistoyLObj.solelist)
				this.$store.commit('upEditableTabs', HistoyLObj.tablist)
				this.$store.commit('setHistTabsValue', HistoyLObj.setHistTabsValue)
				sessionStorage.removeItem('HistoyLObj')
			}
			var list = this.$store.state.uobj.pertb001List
			this.buildMenuCache(list)
			this.buildRouteComponentCache()
			this.userName = this.$store.state.uobj.pertb005.pertb005ca02
			var pertb005ca00 = this.$store.state.uobj.pertb005.pertb005ca00
			this.isFailure()
			var newArr = []
			list.forEach(resitem => {
				newArr.push(resitem)
				resitem.childMenus.forEach(resitem1 => {
					newArr.push(resitem1)
				})
			})
			this.$store.commit('setSole', newArr)
			this.pertb001List = this.$store.state.uobj.pertb001List
			this.oneNavlist = []
			this.twoNavlist = []
			if (this.pertb001List[0]['PERTB001CA03'] != 'systemSettings') {
				this.pertb001List[0].childMenus.forEach(resitem => {
					resitem.childMenus.forEach(item => {
						// console.log(item)
						// if(item.PERTB001CA03=='shtz'){//派单审核
						// 	this.SIAuditDispatchListHome();
						// 	this.queryDispatchAuditHome()
						// }
						// if(item.PERTB001CA03=='SIAuditShtz'){//库存审核
						// 	this.SIAuditListHome();
						// 	this.queryNewAuditHome()
						// }
						// if(item.PERTB001CA03=='salesTopUpAuditShtz'){//销售充值审核
						// 	this.STopUpAuditListHome();
						// 	this.queryTopUpAuditHome()
						// }
					})
				})
			}
			this.pertb001List.forEach(resitem => {
				this.oneNavlist.push(resitem)
			})
			this.twoNavlist = this.pertb001List[0].childMenus
			var NavHistoyLObj = this.$store.state.NavHistoyLObj
			if (NavHistoyLObj != '' && NavHistoyLObj.editableTabs.length > 0) {
				this.pertb001List.forEach(resitem => {
					if (NavHistoyLObj.oneNavDefActive == resitem.PERTB001CA03) {
						this.twoNavlist = resitem.childMenus
					}
				})
				this.oneNavDefActive = NavHistoyLObj.oneNavDefActive
				this.pushRoute(NavHistoyLObj.editableTabsValue)
				this.editableTabs = NavHistoyLObj.editableTabs
				this.$store.commit('upEditableTabs', NavHistoyLObj.editableTabs)
				this.$store.commit('setHistTabsValue', NavHistoyLObj.editableTabsValue)
			} else {
				this.oneNavDefActive = this.oneNavlist[0].PERTB001CA03
				var Stablsit = this.$store.state.tablist.slice()
				Stablsit.push(this.twoNavlist[0])
				this.$store.commit('upEditableTabs', Stablsit)
				this.$store.commit('setHistTabsValue', this.twoNavlist[0].PERTB001CA03)
				this.pushRoute(this.twoNavlist[0].PERTB001CA03)
			}
				this.schedulePreloadRoutes()
		},
		isFailure() { //顶号操作
			if (this.$route.path == '/Login') return
			if (this.keepLoginTimer) {
				clearTimeout(this.keepLoginTimer)
				this.keepLoginTimer = null
			}
			this.axios.get(`system/keepLogin`).then(res => {
				if (res.data.code === 599) {
					if (this.$route.path == '/Login') return
					this.$alert('该账号已在其他地方登录，如非本人操作，请尽快修改密码！', '', {
						confirmButtonText: '确定',
						type: 'warning',
						showClose: false
					}).then(() => {
						this.$router.push('/Login')
						sessionStorage.removeItem('token')
						this.$store.commit('setUser', '')
						this.$store.commit('setNavHistoy', '')
						this.$store.commit('setSole', '')
						this.$store.commit('upEditableTabs', [])
						this.$store.commit('setHistTabsValue', '')
						location.reload()
					}).catch(() => { });
				} else {
					if (this.isHomeDestroyed || this.$route.path == '/Login') return
					this.keepLoginTimer = setTimeout(() => {
						this.isFailure()
					}, 60000)
				}
			}).catch(() => {
				this.$router.push('/Login')
				sessionStorage.removeItem('token')
				this.$store.commit('setUser', '')
				this.$store.commit('setNavHistoy', '')
				this.$store.commit('setSole', '')
				this.$store.commit('upEditableTabs', [])
				this.$store.commit('setHistTabsValue', '')
			});
		},
		upaccount(item) { //切换账号
			var url = '/system/login/logout'
			this.axios.get(url).then((res) => {
				if (res.data.code == 200) {
					this.$router.push('/Login')
				}
			}).catch(() => { });
			var url = '/system/login/secondlogin'
			var data = {
				username: item.pertb005.pertb005ca03,
				password: item.pertb005.pertb005ca01,
				PERTB005CB00: item.pertb005.pertb005cb00,
				PERTB005CD01: item.pertb005.pertb005cd01
			}
			this.axios.post(url, data).then((res) => {
				if (res.data.code == 200) {
					this.oneNavlist = []
					this.twoNavlist = []
					this.$store.commit('setUser', res.data.data)
					this.$store.commit('setNavHistoy', '')
					this.$store.commit('setSole', '')
					this.$store.commit('upEditableTabs', [])
					this.$store.commit('setHistTabsValue', '')
					sessionStorage.setItem('token', res.data.data.token)
					this.$router.push('/Home')
				} else {
					this.$message.error(res.data.message)
				}
			}).catch(() => {
				this.loading = false
			});
		},
		recordActiveTime() { //更新最后操作时间
		this.lastActiveTime = Date.now()
		},
		isTimeOut() { //校验为操作时间
			var currentTime = Date.now() // 记录这次点击的时间
			if (this.$route.path == 'Login') return
			if (currentTime - this.lastActiveTime >= this.timeOut) { // 判断上次最后一次点击的时间和这次点击的时间间隔是否大于30分钟
				if (sessionStorage.getItem('token')) { // 如果是登录状态
					var url = '/system/login/logout'
					this.axios.get(url).then((res) => {
						if (res.data.code == 200) {
							this.$router.push('/Login')
						}
					}).catch(() => { });
				}
			} else {
				setTimeout(() => {
					this.isTimeOut()
				}, 300000)
			}
		}
	}

}
</script>
<style scoped>
.homePC {
	display: flex;
	box-sizing: border-box;
}

.homePC-side {
	box-sizing: border-box;
	/* background-color: #545c64; */
	transition: all 10 cubic-bezier(.23, 1, .32, 1);
	-moz-transition: width .3s;
	/* Firefox 4 */
	-webkit-transition: width .3s;
	/* Safari 和 Chrome */
	-o-transition: width .3s;
	/* Opera */
}

.homePC-side:not(.homePC-side-width) {
	width: 180PX;
	box-sizing: border-box;
}

.homePC-side-width {
	width: 74PX;
	min-width: 74PX;
}

.homePC-side-nav {
	height: 95%;
	padding-bottom: 5PX;
}

.homePC-side-logo {
	overflow: hidden;
	border-bottom: solid 2px #e6e6e6;
}

.homePC-side-logo-text {
	width: 100%;
	line-height: 62px;
	/* background-color: rgba(67,74,80,1); */
	font-size: 20px;
	color: #333;
	padding: 0 0 0 20PX;
	box-sizing: border-box;
	vertical-align: middle;
}

.homePC-side-logo-text>img {
	height: 30px;
	width: 30px;
	margin-right: 10PX;
	vertical-align: middle;
}

.homePC-side-logo-img {
	padding: 20px 0 0 10px;
	background-color: #545c64;
}

.homePC-side-btn {
	position: fixed;
	top: 450px;
	color: #333;
	padding-bottom: 5px;
	vertical-align: top;
	overflow: hidden;
	box-sizing: border-box;
	width: 20px;
	height: 90px;
	line-height: 90px;
	/* background-color: rgba(25, 159, 255, .5); */
	background: url(../../assets/images/home/shallowScaling.png) no-repeat;
	background-size: 100% 100%;
	font-size: 20px;
	color: #FFF;
	text-align: center;
	z-index: 999;
	transition: left .2s;
	-moz-transition: left .2s;
	/* Firefox 4 */
	-webkit-transition: left .2s;
	/* Safari 和 Chrome */
	-o-transition: left .2s;
	/* Opera */
}

.homePC-side-btn:hover {
	background-color: rgba(25, 159, 255, 1);
	background: url(../../assets/images/home/scaling.png) no-repeat;
	background-size: 100% 100%;
}

.homePC-side-btn>div {
	font-size: 14px;
}

.homePC-side-nav-ul:not(.el-menu--collapse) {
	width: 180PX;
	height: 100%;
	overflow: hidden;
}

.homePC-side-btn:not(.homePC-side-btn-left) {
	left: 180PX;
	transition: left .3s;
	-moz-transition: left .3s;
	/* Firefox 4 */
	-webkit-transition: left .3s;
	/* Safari 和 Chrome */
	-o-transition: left .3s;
	/* Opera */
}

.homePC-side-btn-left {
	left: 74PX;
}

.homePC-content {
	position: relative;
	flex: 4;
	padding: 0 10px 0 10px;
	background-color: #F3F3F3;
	box-sizing: border-box;
	overflow-x: auto;
}

.homePC-content-title {
	display: flex;
	min-width: 0;
	box-sizing: border-box;
}

.homePC-content-title-nav {
	flex: 1 1 auto;
	min-width: 0;
	/* height: 60px; */
	box-sizing: border-box;
}

.homePC-content-title-btn {
	height: 60px;
	padding-right: 33px;
	background-color: #FFF;
	box-sizing: border-box;
}

.homePC-content-title-account {
	width: 200px;
	padding: 0 10px;
	box-sizing: border-box;
}

.homePC-content-title-account .el-divider__text {
	width: 120px;
	font-size: 18px;
	text-align: center;
	box-sizing: border-box;
}

.homePC-content-title-account-li {
	height: 40px;
	line-height: 40px;
	font-size: 16px;
	padding: 0 20px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.homePC-content-title-account-li-color {
	color: rgba(25, 159, 255, 1);
}

.homePC-content-title-btn-headerPro {
	display: inline-block;
	margin-top: 10px;
	vertical-align: middle;
}

.homePC-content-title-btn-headerPro div {
	width: 32px;
	height: 32px;
	border-radius: 50%;
}

.homePC-content-title-btn-headerPro div>img {
	width: 100%;
	height: 100%;
}

.homePC-content-title-btn-text {
	display: inline-block;
	margin-left: 10px;
	margin-top: 10px;
	font-size: 14px;
	vertical-align: middle;
	color: #666666;
}

.homePC-content-title-btn-icon {
	display: inline-block;
	margin-left: 20px;
	margin-top: 10px;
	font-size: 25px;
	color: #333;
	vertical-align: middle;
}

.homePC-content-lable {
	margin-top: 1px;
	background-color: #FFF;
	display: flex;
	box-sizing: border-box;
}

.homePC-content-lable-tabs {
	flex: 1 1 auto;
	min-width: 0;
	box-sizing: border-box;
}

.homePC-content-lable-btn {
	height: 41px;
	line-height: 41px;
	padding-right: 33px;
	box-sizing: border-box;
}

.homePC-content-lable-btn .homePC-content-lable-btn-ico {
	display: inline-block;
	width: 40px;
	height: 40px;
	border: 1px solid #f3f3f3;
	text-align: center;
	color: #666666;
	border-top-color: #f3f3f357 !important;
}

.homePC-content-lable-btn-COT {
	font-size: 14px;
	color: #666;
	text-align: center;
}

.homePC-content-lable-btn-COT>ul>li {
	line-height: 30px;
	padding: 0 12px;
}

.homePC-content-lable-btn-COT>ul>li:hover {
	background-color: #eee;
}

.homePC-content-router {
	background-color: #FFF;
}

.oneLevelSty li {
	padding: 0px 24px !important;
}

/* 个人信息 */
.systemUserPC-add-user {
	padding-left: 20px;
}

.systemUserPC-add-user-li {
	display: flex;
	height: 42px;
	line-height: 42px;
	text-align: center;
	font-size: 16px;
	color: #333;
}

.systemUserPC-add-user-li>div {
	flex: 1;
	border: 1px solid #CDCDCD;
	border-top: none;
}

.systemUserPC-add-user-li:first-child>div {
	border-top: 1px solid #CDCDCD;
}

.systemUserPC-add-user-li>div:last-child {
	flex: .3;
	border: none;
	color: #FF4D35;
}

.systemUserPC-add-user-li>div:first-child {
	border-right: none;
	background: rgba(240, 252, 255, 1);
}

.systemUserPC-add-user-li input {
	border: none;
	height: 100%;
	width: 100%;
	box-sizing: border-box;
	vertical-align: top;
	text-align: center;
	font-size: 16px;
}

.systemUserPC-add-user-btn {
	text-align: center;
	padding: 40px 0 20px 0;
}

/* 定义过渡样式 */
.fade-enter-active,
.fade-leave-active {
	transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active for <=2.1.8 */
	{
	opacity: 0;
}

/* 页面框架视觉优化 */
.homePC {
	min-height: 100vh;
	background: linear-gradient(135deg, #eef5fc 0%, #f7fbff 50%, #edf6ff 100%);
}

.homePC-side {
	position: relative;
	z-index: 3;
	background: #ffffff;
	border-right: 1px solid #e3edf7;
	box-shadow: 8px 0 24px rgba(28, 72, 116, 0.06);
}

.homePC-side-nav {
	height: 100%;
	background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.homePC-side-logo {
	border-bottom: 1px solid #e5edf6;
	background: linear-gradient(135deg, #ffffff 0%, #edf7ff 100%);
}

.homePC-side-logo-text {
	line-height: 66px;
	font-weight: 700;
	letter-spacing: 1px;
	color: #183b56;
}

.homePC-side-logo-text>img {
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(23, 139, 255, 0.16);
}

.homePC-side-btn {
	top: 50%;
	margin-top: -45px;
	filter: drop-shadow(0 6px 12px rgba(23, 139, 255, 0.20));
}

.homePC-content {
	padding: 0 16px 18px;
	background: transparent;
	overflow-x: auto;
}

.homePC-content-title {
	position: sticky;
	top: 0;
	z-index: 2;
	align-items: stretch;
	min-height: 62px;
	margin: 0 -16px;
	padding: 0 16px;
	background: rgba(255, 255, 255, 0.94);
	border-bottom: 1px solid #e3edf7;
	box-shadow: 0 8px 24px rgba(28, 72, 116, 0.05);
	backdrop-filter: blur(8px);
}

.homePC-content-title-nav,
.homePC-content-title-btn {
	background: transparent;
}

.homePC-content-title-btn {
	display: flex;
	align-items: center;
	height: 62px;
	padding-right: 8px;
}

.homePC-content-title-btn-headerPro {
	margin-top: 0;
}

.homePC-content-title-btn-headerPro div {
	width: 36px;
	height: 36px;
	padding: 2px;
	background: #ffffff;
	box-shadow: 0 4px 12px rgba(28, 72, 116, 0.12);
}

.homePC-content-title-btn-text {
	margin-top: 0;
	line-height: 18px;
	color: #344563;
}

.homePC-content-title-btn-text p:first-child {
	font-weight: 600;
	color: #1f2d3d;
}

.homePC-content-title-btn-text p:last-child {
	max-width: 160px;
	color: #7a8ca5;
	font-size: 12px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.homePC-content-title-btn-icon {
	margin-top: 0;
	width: 36px;
	height: 36px;
	line-height: 36px;
	text-align: center;
	border-radius: 50%;
	color: #5f6f84;
	background: #f4f8fc;
}

.homePC-content-title-btn-icon:hover {
	color: #ff5a45;
	background: rgba(255, 90, 69, 0.10);
}

.homePC-content-title-account {
	padding: 4px;
}

.homePC-content-title-account-li {
	border-radius: 6px;
	transition: background-color .18s ease, color .18s ease;
}

.homePC-content-title-account-li-color {
	color: #178bff;
	background: #eaf5ff;
	font-weight: 600;
}

.homePC-content-lable {
	margin-top: 12px;
	border: 1px solid #e3edf7;
	border-radius: 10px;
	box-shadow: 0 4px 14px rgba(18, 52, 77, 0.05);
	overflow: hidden;
}

.homePC-content-lable-btn {
	padding-right: 12px;
	background: #ffffff;
}

.homePC-content-lable-btn .homePC-content-lable-btn-ico {
	border-color: #e3edf7;
	border-radius: 6px;
	transition: color .18s ease, background-color .18s ease;
}

.homePC-content-lable-btn .homePC-content-lable-btn-ico:hover {
	color: #178bff;
	background: #eaf5ff;
}

.homePC-content-lable-btn-COT>ul>li {
	border-radius: 6px;
	transition: background-color .18s ease, color .18s ease;
}

.homePC-content-lable-btn-COT>ul>li:hover {
	color: #178bff;
	background-color: #eaf5ff;
}

.homePC-content-router {
	min-height: calc(100vh - 128px);
	margin-top: 12px;
	background: transparent;
}

.systemUserPC-add-user {
	padding: 6px 10px 0;
}

.systemUserPC-add-user-li>div {
	border-color: #dce6f2;
}

.systemUserPC-add-user-li>div:first-child {
	background: #f0f8ff;
	font-weight: 600;
	color: #344563;
}

.systemUserPC-add-user-li input {
	color: #1f2d3d;
}

.systemUserPC-add-user-btn {
	padding: 28px 0 12px;
}

@media screen and (max-width: 1440px) {
	.homePC-content {
		padding: 0 12px 14px;
	}

	.homePC-content-title {
		margin: 0 -12px;
		padding: 0 12px;
	}

	.homePC-content-title-btn {
		padding-right: 0;
	}

	.homePC-content-title-btn-text p:last-child {
		max-width: 120px;
	}

	.oneLevelSty li {
		padding: 0 18px !important;
	}
}

@media screen and (max-width: 1280px) {
	.homePC-side:not(.homePC-side-width),
	.homePC-side-nav-ul:not(.el-menu--collapse) {
		width: 188PX;
	}

	.homePC-side-btn:not(.homePC-side-btn-left) {
		left: 188PX;
	}

	.homePC-side-logo-text {
		padding-left: 14PX;
		font-size: 18px;
	}

	.homePC-content-title,
	.homePC-content-lable {
		min-width: 960px;
	}

	.homePC-content-lable-tabs {
		width: auto;
		min-width: 0;
	}

	.homePC-content-title-btn-text {
		display: none;
	}

	.homePC-content-title-btn-icon {
		margin-left: 10px;
	}
}

@media screen and (max-width: 1024px) {
	.homePC {
		min-width: 980px;
	}

	.homePC-content {
		padding: 0 10px 12px;
	}

	.homePC-content-title {
		position: relative;
		margin: 0 -10px;
		padding: 0 10px;
	}

	.homePC-content-title-account {
		width: 160px;
	}

	.homePC-content-lable,
	.homePC-content-router {
		margin-top: 10px;
	}

	.homePC-content-router {
		min-height: calc(100vh - 118px);
	}
}

/* 页面框架重构收敛层 */
.homePC {
	position: relative;
	width: 100%;
	min-height: 100vh;
	background:
		radial-gradient(circle at 12% 0%, rgba(23, 139, 255, 0.12) 0, rgba(23, 139, 255, 0) 30%),
		linear-gradient(135deg, #edf5fc 0%, #f7fbff 46%, #eef6ff 100%);
	color: var(--fszs-text);
}

.homePC-side {
	position: relative;
	z-index: 4;
	background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
	border-right: 1px solid rgba(220, 230, 242, 0.95);
	box-shadow: 10px 0 26px rgba(18, 52, 77, 0.07);
	transition: width .22s ease, min-width .22s ease;
}

.homePC-side:not(.homePC-side-width) {
	width: 216PX;
}

.homePC-side-nav-ul:not(.el-menu--collapse) {
	width: 216PX;
}

.homePC-side-width {
	width: 72PX;
	min-width: 72PX;
}

.homePC-side-logo {
	border-bottom: 1px solid var(--fszs-border-soft);
	background:
		linear-gradient(135deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 55%),
		#ffffff;
}

.homePC-side-logo-text {
	height: 66px;
	line-height: 66px;
	padding-left: 18PX;
	color: var(--fszs-text-strong);
	font-size: 19px;
	font-weight: 700;
	letter-spacing: .8px;
}

.homePC-side-logo-text>img {
	width: 34px;
	height: 34px;
	margin-right: 10PX;
	border-radius: 9px;
	box-shadow: 0 7px 16px rgba(23, 139, 255, 0.20);
}

.homePC-side-nav-ul {
	padding: 10px 8px 14px;
	background: transparent !important;
	border-right: none;
	box-sizing: border-box;
}

.homePC-side-nav-ul .el-menu-item span {
	font-size: 15px;
	font-weight: 600;
	color: #1a2e40;
	letter-spacing: 0.5px;
}

.homePC-side-nav-ul .el-menu-item {
	position: relative;
	box-sizing: border-box;
	border-radius: 8px;
	margin-bottom: 2px;
	border-left: 3px solid transparent;
	transition: border-color 0.2s, background 0.2s;
}

.homePC-side-nav-ul:not(.el-menu--collapse) .el-menu-item {
	padding: 0 10PX !important;
}

.homePC-side-nav-ul .el-menu-item i {
	margin-right: 8PX;
}

.homePC-side-nav-ul .el-menu-item:hover {
	background: rgba(23, 139, 255, 0.07) !important;
	border-left-color: rgba(23, 139, 255, 0.5);
}

.homePC-side-nav-ul .el-menu-item.is-active {
	background: rgba(23, 139, 255, 0.12) !important;
	border-left-color: #178bff;
}

.homePC-side-nav-ul .el-menu-item.is-active span {
	color: #178bff;
}

.homePC-side-btn:not(.homePC-side-btn-left) {
	left: 216PX;
}

.homePC-side-btn-left {
	left: 72PX;
}

.homePC-side-btn {
	top: 50%;
	margin-top: -45px;
	filter: drop-shadow(0 8px 14px rgba(23, 139, 255, 0.24));
	transition: left .22s ease, transform .18s ease;
}

.homePC-side-btn:hover {
	transform: translateX(1px);
}

.homePC-content {
	position: relative;
	flex: 1 1 auto;
	min-width: 0;
	padding: 0 16px 18px;
	background: transparent;
	overflow-x: auto;
}

.homePC-content-title {
	position: sticky;
	top: 0;
	z-index: 3;
	align-items: stretch;
	min-height: 64px;
	margin: 0 -16px;
	padding: 0 16px;
	background: rgba(255, 255, 255, 0.96);
	border-bottom: 1px solid rgba(220, 230, 242, 0.95);
	box-shadow: 0 8px 24px rgba(18, 52, 77, 0.06);
	backdrop-filter: blur(8px);
}

.homePC-content-title-nav {
	display: flex;
	align-items: center;
	overflow-x: auto;
	overflow-y: hidden;
}

.oneLevelSty {
	background: transparent !important;
}

.oneLevelSty li {
	height: 64px !important;
	line-height: 64px !important;
	padding: 0 22px !important;
	border-bottom: none !important;
	color: #1a2e40 !important;
	font-size: 16px !important;
	font-weight: 700;
	letter-spacing: 0.8px;
	position: relative;
	transition: color 0.2s;
}

.oneLevelSty li::after {
	content: '';
	position: absolute;
	bottom: 0;
	left: 22px;
	right: 22px;
	height: 3px;
	border-radius: 3px 3px 0 0;
	background: #178bff;
	transform: scaleX(0);
	transition: transform 0.25s ease;
}

.oneLevelSty li:hover {
	color: #178bff !important;
	background: rgba(23, 139, 255, 0.05) !important;
}

.oneLevelSty li:hover::after {
	transform: scaleX(0.7);
}

.oneLevelSty li.is-active {
	color: #178bff !important;
	background: rgba(23, 139, 255, 0.08) !important;
}

.oneLevelSty li.is-active::after {
	transform: scaleX(1);
}

.homePC-content-title-btn {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	height: 64px;
	padding-right: 0;
	background: transparent;
}

.homePC-content-title-btn-headerPro {
	margin-top: 0;
}

.homePC-content-title-btn-headerPro div {
	width: 38px;
	height: 38px;
	padding: 2px;
	background: #ffffff;
	border: 1px solid var(--fszs-border-soft);
	box-shadow: 0 6px 14px rgba(18, 52, 77, 0.10);
	box-sizing: border-box;
}

.homePC-content-title-btn-text {
	max-width: 190px;
	margin-top: 0;
	margin-left: 10px;
	padding: 6px 10px;
	border-radius: 10px;
	line-height: 18px;
	color: var(--fszs-text-muted);
	transition: background-color .18s ease;
}

.homePC-content-title-btn-text:hover {
	background: var(--fszs-primary-soft);
}

.homePC-content-title-btn-text p:first-child {
	color: var(--fszs-text-strong);
	font-weight: 700;
}

.homePC-content-title-btn-text p:last-child {
	max-width: 160px;
	color: var(--fszs-text-subtle);
	font-size: 12px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.homePC-content-title-btn-icon {
	width: 38px;
	height: 38px;
	line-height: 38px;
	margin-top: 0;
	margin-left: 10px;
	border-radius: 50%;
	color: #65758a;
	font-size: 23px;
	text-align: center;
	background: #f3f8fd;
	transition: color .18s ease, background-color .18s ease, transform .18s ease;
}

.homePC-content-title-btn-icon:hover {
	color: var(--fszs-danger);
	background: rgba(255, 90, 69, 0.10);
	transform: translateY(-1px);
}

.homePC-content-title-account {
	padding: 4px;
}

.homePC-content-title-account .el-divider__text {
	color: var(--fszs-text-muted);
	font-size: 14px;
}

.homePC-content-title-account-li {
	height: 36px;
	line-height: 36px;
	padding: 0 12px;
	border-radius: 8px;
	font-size: 14px;
	transition: color .18s ease, background-color .18s ease;
}

.homePC-content-title-account-li-color {
	color: var(--fszs-primary);
	background: var(--fszs-primary-soft);
	font-weight: 700;
}

.homePC-content-lable {
	min-height: 42px;
	margin-top: 12px;
	background: rgba(255, 255, 255, 0.94);
	border: 1px solid rgba(220, 230, 242, 0.95);
	border-radius: var(--fszs-radius-md);
	box-shadow: var(--fszs-shadow-sm);
	overflow: hidden;
}

.homePC-content-lable-tabs {
	display: flex;
	align-items: center;
}

.homePC-content-lable-btn {
	flex: 0 0 auto;
	height: 42px;
	line-height: 42px;
	padding-right: 10px;
	background: #ffffff;
}

.homePC-content-lable-btn .homePC-content-lable-btn-ico {
	width: 36px;
	height: 34px;
	line-height: 34px;
	margin-top: 4px;
	border: 1px solid var(--fszs-border-soft);
	border-radius: 8px;
	color: var(--fszs-text-muted);
	transition: color .18s ease, background-color .18s ease;
}

.homePC-content-lable-btn .homePC-content-lable-btn-ico:hover,
.homePC-content-lable-btn-COT>ul>li:hover {
	color: var(--fszs-primary);
	background: var(--fszs-primary-soft);
}

.homePC-content-lable-btn-COT {
	padding: 4px;
	font-size: 14px;
	color: var(--fszs-text-muted);
}

.homePC-content-lable-btn-COT>ul>li {
	line-height: 34px;
	border-radius: 8px;
	transition: color .18s ease, background-color .18s ease;
}

.homePC-content-router {
	min-height: calc(100vh - 132px);
	margin-top: 12px;
	background: transparent;
	border-radius: var(--fszs-radius-lg);
}

.systemUserPC-add-user {
	padding: 6px 10px 0;
}

.systemUserPC-add-user-li {
	height: 40px;
	line-height: 40px;
	font-size: 14px;
}

.systemUserPC-add-user-li>div {
	border-color: var(--fszs-border);
}

.systemUserPC-add-user-li>div:first-child {
	background: var(--fszs-primary-faint);
	color: var(--fszs-text-muted);
	font-weight: 700;
}

.systemUserPC-add-user-btn {
	display: flex;
	justify-content: flex-end;
	gap: 10px;
	padding: 22px 0 8px;
}

@media screen and (max-width: 1440px) {
	.homePC-content {
		padding: 0 12px 14px;
	}

	.homePC-content-title {
		margin: 0 -12px;
		padding: 0 12px;
	}

	.oneLevelSty li {
		padding: 0 18px !important;
	}
}

@media screen and (max-width: 1280px) {
	.homePC-side:not(.homePC-side-width),
	.homePC-side-nav-ul:not(.el-menu--collapse) {
		width: 196PX;
	}

	.homePC-side-btn:not(.homePC-side-btn-left) {
		left: 196PX;
	}

	.homePC-content-title,
	.homePC-content-lable {
		min-width: 920px;
	}

	.homePC-content-title-btn-text {
		display: none;
	}
}

@media screen and (max-width: 1024px) {
	.homePC {
		min-width: 980px;
	}

	.homePC-content-router {
		min-height: calc(100vh - 118px);
	}
}

/* 折叠屏展开态适配（768px ~ 1024px），不影响PC端 */
@media screen and (min-width: 768px) and (max-width: 1024px) and (hover: none) and (pointer: coarse) {
	.homePC {
		min-width: 0 !important;
	}

	.homePC-side:not(.homePC-side-width) {
		width: 72px !important;
		min-width: 72px !important;
	}

	.homePC-side:not(.homePC-side-width) .homePC-side-nav-ul:not(.el-menu--collapse) {
		width: 72px !important;
	}

	.homePC-side:not(.homePC-side-width) + .homePC-content {
		left: 72px !important;
	}

	.homePC-side-btn:not(.homePC-side-btn-left) {
		left: 72px !important;
	}

	.homePC-side-nav-ul .el-menu-item span {
		display: none;
	}

	.homePC-content-title-nav {
		overflow-x: auto;
	}

	.homePC-content-router {
		min-height: calc(100vh - 118px);
	}
}


	/* 固定侧边栏，右侧内容独立滚动 */
	.home {
		height: 100vh;
		overflow: hidden;
	}

	.homePC {
		display: block;
		height: 100vh;
		min-height: 100vh;
		overflow: hidden;
	}

	.homePC-side {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		height: 100vh;
		min-height: 0 !important;
		z-index: 20;
	}

	.homePC-side:not(.homePC-side-width) {
		width: 216PX;
		min-width: 216PX;
	}

	.homePC-side:not(.homePC-side-width) .homePC-side-nav-ul:not(.el-menu--collapse) {
		width: 216PX;
	}

	.homePC-side-nav {
		display: flex;
		flex-direction: column;
		height: 100%;
		overflow: hidden;
	}

	.homePC-side-nav-ul {
		flex: 1 1 auto;
		min-height: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.homePC-side-btn {
		position: fixed;
		top: 50%;
		width: 30px;
		height: 30px;
		line-height: 30px;
		margin-top: -15px;
		padding: 0;
		color: #178bff;
		font-size: 16px;
		text-align: center;
		background: #ffffff;
		border: 1px solid rgba(23, 139, 255, 0.22);
		border-radius: 50%;
		box-shadow: 0 6px 16px rgba(23, 139, 255, 0.22);
		overflow: visible;
		z-index: 30;
		transition: left .22s ease, color .18s ease, background-color .18s ease, box-shadow .18s ease, transform .18s ease;
	}

	.homePC-side-btn:hover {
		color: #ffffff;
		background: linear-gradient(135deg, #178bff 0%, #42a5ff 100%);
		box-shadow: 0 8px 20px rgba(23, 139, 255, 0.34);
		transform: translateX(1px);
	}

	.homePC-side-btn span {
		display: inline-block;
		line-height: 30px;
	}

	.homePC-side:not(.homePC-side-width) + .homePC-content {
		left: 216PX;
	}

	.homePC-side-width + .homePC-content {
		left: 72PX;
	}

	.homePC-content {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		height: 100vh;
		min-height: 0;
		width: auto !important;
		margin-left: 0 !important;
		box-sizing: border-box;
		padding: 0;
		overflow-x: auto;
		overflow-y: auto;
		transition: left .22s ease;
	}

	.homePC-content-title {
		position: sticky;
		top: 0;
		z-index: 6;
		margin-left: 0;
	}

	.homePC-content-lable {
		position: sticky;
		top: 64px;
		z-index: 5;
		margin-top: 0;
		border-radius: 0;
	}

	.homePC-content-router {
		margin-top: 12px;
	}

	@media screen and (max-width: 1280px) {
		.homePC-side:not(.homePC-side-width) {
			width: 188PX;
			min-width: 188PX;
		}

		.homePC-side:not(.homePC-side-width) .homePC-side-nav-ul:not(.el-menu--collapse) {
			width: 188PX;
		}

		.homePC-side-btn:not(.homePC-side-btn-left) {
			left: 188PX;
		}

		.homePC-side:not(.homePC-side-width) + .homePC-content {
			left: 188PX;
		}
	}

		@media screen and (max-width: 768px) {
			.home {
				height: auto;
				min-height: 100vh;
				overflow-x: hidden;
				overflow-y: auto;
			}

			.homePC {
				display: flex;
				flex-direction: column;
				height: auto;
				min-height: 100vh;
				min-width: 0 !important;
				overflow: visible;
			}

			.homePC-side,
			.homePC-side:not(.homePC-side-width),
			.homePC-side-width {
				position: relative;
				top: auto;
				bottom: auto;
				left: auto;
				width: 100% !important;
				min-width: 0 !important;
				height: auto;
				min-height: auto !important;
				border-right: none;
				border-bottom: 1px solid rgba(220, 230, 242, 0.95);
				box-shadow: 0 6px 18px rgba(18, 52, 77, 0.06);
			}

			.homePC-side-nav {
				display: block;
				height: auto;
				overflow: visible;
			}

			.homePC-side-logo {
				display: none;
			}

			.homePC-side-nav-ul,
			.homePC-side-nav-ul:not(.el-menu--collapse),
			.homePC-side:not(.homePC-side-width) .homePC-side-nav-ul:not(.el-menu--collapse) {
				display: flex;
				width: 100% !important;
				height: auto;
				min-height: auto;
				padding: 6px 8px 8px;
				overflow-x: auto;
				overflow-y: hidden;
				border-right: none;
				box-sizing: border-box;
				scrollbar-width: none;
				-ms-overflow-style: none;
			}

			.homePC-side-nav-ul::-webkit-scrollbar {
				display: none;
			}

			.homePC-content-title-nav::-webkit-scrollbar {
				display: none;
			}

			.homePC-content-title-nav {
				scrollbar-width: none;
				-ms-overflow-style: none;
			}

			.homePC-side-nav-ul .el-menu-item {
				flex: 0 0 auto;
				height: 42px !important;
				line-height: 42px !important;
				margin: 0 6px 0 0;
				padding: 0 12px !important;
				border-left: none;
				white-space: nowrap;
			}

			.homePC-side-nav-ul .el-menu-item span {
				display: inline-block;
				width: auto;
				height: auto;
				visibility: visible;
			}

			.homePC-side-btn {
				display: none;
			}

			.homePC-side:not(.homePC-side-width) + .homePC-content,
			.homePC-side-width + .homePC-content,
			.homePC-content {
				position: relative;
				top: auto;
				right: auto;
				bottom: auto;
				left: auto !important;
				width: 100% !important;
				height: auto;
				min-height: 0;
				padding: 0 8px 12px;
				overflow-x: hidden;
				overflow-y: visible;
				transition: none;
			}

			.homePC-content-title,
			.homePC-content-lable {
				min-width: 0 !important;
				width: auto;
				margin-left: -8px;
				margin-right: -8px;
				padding-left: 8px;
				padding-right: 8px;
				box-sizing: border-box;
			}

			.homePC-content-title {
				position: sticky;
				top: 0;
				min-height: 54px;
				z-index: 6;
				overflow: hidden;
			}

			.homePC-content-title-nav {
				min-width: 0;
				overflow-x: auto;
				overflow-y: hidden;
			}

			.oneLevelSty li {
				height: 54px !important;
				line-height: 54px !important;
				padding: 0 14px !important;
				font-size: 14px !important;
				white-space: nowrap;
			}

			.homePC-content-title-btn {
				height: 54px;
				padding-left: 8px;
			}

			.homePC-content-title-btn-headerPro div,
			.homePC-content-title-btn-icon {
				width: 34px;
				height: 34px;
				line-height: 34px;
			}

			.homePC-content-title-btn-icon {
				margin-left: 6px;
				font-size: 20px;
			}

			.homePC-content-lable {
				position: relative;
				top: auto;
				min-height: 38px;
				margin-top: 8px;
				border-radius: 8px;
				overflow: hidden;
			}

			.homePC-content-lable-tabs {
				width: auto !important;
				min-width: 0;
				overflow-x: auto;
				overflow-y: hidden;
			}

			.homePC-content-lable-btn {
				height: 38px;
				line-height: 38px;
				padding-right: 4px;
			}

			.homePC-content-lable-btn .homePC-content-lable-btn-ico {
				width: 32px;
				height: 30px;
				line-height: 30px;
			}

			.homePC-content-router {
				min-height: auto;
				margin-top: 8px;
				overflow-x: hidden;
			}
		}
</style>
<style>
.home-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.home-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.home-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.home-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.home-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
